import * as React from "react";

function SvgTiktokIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
      <path d="M20 0a20 20 0 1020 20A20.002 20.002 0 0020 0z" fill="#010101" />
      <g fillRule="evenodd">
        <path
          d="M26.07 15.842a10.563 10.563 0 006.161 1.97v-4.419a6.231 6.231 0 01-1.294-.135v3.478a10.564 10.564 0 01-6.161-1.97v9.018a8.174 8.174 0 01-12.722 6.786 8.173 8.173 0 0014.016-5.71v-9.018zm1.596-4.459a6.158 6.158 0 01-1.596-3.605v-.569h-1.227a6.186 6.186 0 002.823 4.175zM14.908 27.11a3.739 3.739 0 014.11-5.824v-4.517a8.253 8.253 0 00-1.293-.075v3.517a3.737 3.737 0 00-2.816 6.899z"
          fill="#ee1d52"
        />
        <path
          d="M24.776 14.766a10.564 10.564 0 006.161 1.97v-3.478a6.185 6.185 0 01-3.271-1.875 6.186 6.186 0 01-2.823-4.174h-3.22v17.65a3.74 3.74 0 01-6.715 2.25 3.738 3.738 0 012.817-6.899v-3.517a8.167 8.167 0 00-5.671 13.877 8.174 8.174 0 0012.722-6.787z"
          fill="#fff"
        />
        <path
          d="M30.937 13.258v-.94a6.162 6.162 0 01-3.271-.935 6.18 6.18 0 003.271 1.875zm-6.094-6.049q-.044-.252-.067-.507v-.569h-4.448v17.65a3.74 3.74 0 01-5.42 3.325 3.74 3.74 0 006.715-2.249V7.21zm-7.118 9.484v-1.001a8.181 8.181 0 00-9.294 8.092 8.159 8.159 0 003.623 6.786 8.167 8.167 0 015.67-13.877z"
          fill="#69c9d0"
        />
      </g>
    </svg>
  );
}

export default SvgTiktokIcon;
